{
    "ComparisonTypeLabel": "Quando:",
    "ComparisonTypeOptionNone": "[Nessun allarme]",
    "ComparisonTypeOptionHigherThan": "Superiore a",
    "ComparisonTypeOptionHigherEqual": "Superiore\/uguale",
    "ComparisonTypeOptionLowerThan": "Inferiore a",
    "ComparisonTypeOptionLowerEqual": "Inferiore\/uguale",
    "ComparisonTypeOptionBetween": "Tra",
    "ComparisonTypeOptionEqual": "Pari",
    "ComparisonTypeOptionNotEqual": "Non uguale",
    "ComparisonTypeOptionNotBetween": "Non tra",
    "ComparisonTypeValue": "Valore:",
    "ComparisonTypeAnd": "E",
    "AlarmTypeLabel": "Tipo di allarme:",
    "AlarmTypeNoSound": "[Nessun suono]",
    "AlarmTypeAirRaidSiren": "Sirena antiaerea",
    "AlarmTypeAlarmClock": "Sveglia",
    "AlarmTypeDing": "Ding",
    "AlarmTypeDoorChime": "Suono della porta",
    "AlarmTypeEmergencyServices": "Servizi di emergenza",
    "AlarmTypeFastenSeatBelt": "Allacciare la cintura di sicurezza",
    "AlarmTypeKerching": "Kerching",
    "AlarmTypePhone": "Telefono",
    "AlarmTypeQuickBleep": "Bleep veloce",
    "AlarmTypeRadar": "Radar",
    "AlarmTypeSonarPing": "Sonar Ping",
    "AlarmTypeTarget": "Obiettivo",
    "AlarmTypeTing": "Ting",
    "AlarmTypeWarningBeep": "Segnale acustico di avvertimento",
    "AlarmTypeWarningBuzzer": "Cicalino di avviso",
    "AlarmRepeatTypeLabel": "Tipo di riproduzione:",
    "AlarmRepeatOnce": "Una volta",
    "AlarmRepeatSeconds": "Secondi",
    "AlarmRepeatPersistent": "Persistente",
    "AlarmRepeatRepeat": "Ripetere",
    "AlarmSettingsLabel": "Valore:",
    "StatisticAlarm_SectionHeader": "Allarme statistico",
    "NAME": "StatisticAlarm",
    "AlarmType_Air Raid Siren": "Sirena antiaerea",
    "AlarmType_Alarm Clock": "Sveglia",
    "AlarmType_Barking": "Abbaiare",
    "AlarmType_Birds": "Uccelli",
    "AlarmType_Cat": "Gatto",
    "AlarmType_Chips": "Patatine",
    "AlarmType_Coin Drop": "Goccia di moneta",
    "AlarmType_Computer": "Computer",
    "AlarmType_Cow": "Mucca",
    "AlarmType_Crowd": "Folla",
    "AlarmType_Dial Tone": "Tono di chiamata",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie Horn",
    "AlarmType_Door Chime": "Suono della porta",
    "AlarmType_Emergency Services": "Servizi di emergenza",
    "AlarmType_Fasten Seat Belt": "Allacciare la cintura di sicurezza",
    "AlarmType_Fire Truck": "Camion dei pompieri",
    "AlarmType_Gunshot": "Colpo di pistola",
    "AlarmType_Hammer": "Martello",
    "AlarmType_Helicopter": "Elicottero",
    "AlarmType_Ice Cubes": "Cubetti di ghiaccio",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Risate",
    "AlarmType_Marbles": "Biglie",
    "AlarmType_Monkey": "Scimmia",
    "AlarmType_Morse Code": "Codice Morse",
    "AlarmType_Night Time": "Notte",
    "AlarmType_Owl": "Gufo",
    "AlarmType_Phone": "Telefono",
    "AlarmType_Pool": "Piscina",
    "AlarmType_Pouring Water": "Versare l'acqua",
    "AlarmType_Quick Bleep": "Bleep veloce",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Ricarica",
    "AlarmType_Rocks Falling": "Caduta di sassi",
    "AlarmType_Rooster": "Gallo",
    "AlarmType_Sawing": "Segare",
    "AlarmType_School Bell": "Campanella della scuola",
    "AlarmType_Seaguls": "Gabbiani",
    "AlarmType_Service Bell": "Campana di servizio",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Sonar Ping",
    "AlarmType_Splash": "Splash",
    "AlarmType_Steam Train": "Treno a vapore",
    "AlarmType_Submarine": "Sottomarino",
    "AlarmType_Target": "Obiettivo",
    "AlarmType_Thunder": "Tuono",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Campana del tintinnio",
    "AlarmType_Trombone": "Trombone",
    "AlarmType_Twinkle": "Scintillio",
    "AlarmType_Walking": "Camminare",
    "AlarmType_Whistling": "Fischietto",
    "AlarmType_Warning Beep": "Segnale acustico di avvertimento",
    "AlarmType_Warning Buzzer": "Cicalino di avviso"
}